// 获取验证码
export default {
  data() {
    return {
      getCodeCount: 0,
      getCodeTimer: null
    }
  },
  beforeDestroy() {
    this.handleClearCountTimer()
  },
  methods: {
    // 倒计时
    handleCountDownAction(validKey) {
      this.getCodeCount = 60
      this.getCodeTimer = setInterval(() => {
        let getCodeCount = this.getCodeCount
        getCodeCount--
        if (getCodeCount <= 0) {
          this.handleClearCountTimer()
        }
        this.getCodeCount = getCodeCount
      }, 1000)
    },
    handleClearCountTimer() {
      clearInterval(this.getCodeTimer)
      this.getCodeTimer = null
    }
  }
}
